import { vMailto } from '~~/app/utils/mailto'

/**
 * Rejestruje dyrektywę `v-mailto` (linki e-mail odporne na Cloudflare Email
 * Obfuscation — patrz app/utils/mailto.ts).
 *
 * Plugin UNIWERSALNY (nie `.client`): na serwerze dyrektywa dokłada `href`
 * przez `getSSRProps`, więc musi rozwiązywać się także w SSR.
 */
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('mailto', vMailto)
})
